<h3 mat-dialog-title>Gerador de Ordens de Renda Variável</h3>
<div mat-dialog-content>
    <div fxLayout="row wrap">

        <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
            <mat-form-field style="width: 50%"  appearance="outline" fxFlex="100" floatLabel="always">
                <mat-label>Rótulo</mat-label>
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="rotulo"                     
                    required
                    maxlength="255"
                >         
                <mat-error *ngIf="rotulo.invalid">{{getErrorRotuloMessage()}}</mat-error>
            </mat-form-field>
        </div>
        
        <div fxFlex.gt-sm="100%">            
            <mat-form-field appearance="outline" fxFlex="100" floatLabel="always">
                <mat-label>Estratégia</mat-label>                        
                <mat-select
                    [formControl]="estrategia_id"
                    name="estrategia_id"
                    (selectionChange)="selectBoletas($event, 'estrategia_id')"
                    required                    
                >
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option *ngFor="let estrategia of listEstrategia" [value]="estrategia.id">{{estrategia.nome}}</mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                    <mat-error *ngIf="estrategia_id.invalid">{{getErrorEstrategiaMessage()}}</mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" fxFlex="100" floatLabel="always">
                <mat-label>Status</mat-label>                        
                <mat-select
                    [formControl]="status_id"
                    name="status_id"                    
                    (selectionChange)="selectBoletas($event, 'status_id')"
                    multiple         
                >                              
                        <mat-option *ngFor="let status of listStatus" [value]="status.id">{{status.nome}}</mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>                    
            </mat-form-field>
        </div>       

        <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
            <mat-form-field appearance="outline" fxFlex="100" floatLabel="always">
                <mat-label>Qtd. Trades</mat-label>                        
                <mat-select
                    [formControl]="qtd_trade"
                    name="qtd_trade"
                    (selectionChange)="selectBoletas($event, 'qtd_trade')"
                >
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option 
                            *ngFor="let trades of listTrades" 
                            [value]="trades.total_trades"
                        >
                            {{trades.total_trades == 0 ? 'Dinheiro Novo' : trades.total_trades}}
                        </mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerTrades"></mat-spinner>                    
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Tipo</mat-label>
                <mat-select 
                    [(value)]="model.tipo" 
                    [formControl]="tipo"
                    name="tipo_opcao"
                    required
                >
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option value="C">Coletivo</mat-option>
                    <mat-option value="I" disabled>Individual</mat-option>
                </mat-select>
                <mat-error *ngIf="tipo.invalid">{{getErrorTipoMessage()}}</mat-error>
            </mat-form-field>           
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
            <p>
                Total de Boletas: {{ totalBoletas }}
            </p>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Criar
    </button>
</div>